/**
 * Get admin ID from JWT token
 */
export const getAdminIdFromToken = (): string | null => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    // Decode JWT token
    const payload = JSON.parse(atob(token.split(".")[1]));

    // Try different possible field names for admin ID
    return (
      payload.adminId || payload._id || payload.id || payload.userId || null
    );
  } catch (error) {
    return null;
  }
};
